import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess,
  Dictionary,
  ReadonlyHttpApiCollectionRepository,
  Result,
} from '@softline/core';
import { Artikel } from '../data/product';
import { SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_ARTIKEL } from '../rohstoffbereitstellung.api';

@Injectable()
export class MilchartikelRepository extends ReadonlyHttpApiCollectionRepository<
  Result<Artikel[]>,
  any
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_ROHSTOFFBEREITSTELLUNG_ARTIKEL);
  }

  protected override getLoadPathParams(params: null): Dictionary<unknown> | undefined {
    return super.getLoadPathParams(params);
  }
}
